export const NAV = {
  logo: "nav-logo",
  explore: "nav-explore",
  destinations: "nav-destinations",
  experiences: "nav-experiences",
  becomeHost: "nav-become-host",
  wishlist: "nav-wishlist",
  login: "nav-login",
  bookNow: "nav-book-now",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  searchDestination: "hero-search-destination",
  searchCheckin: "hero-search-checkin",
  searchCheckout: "hero-search-checkout",
  searchGuests: "hero-search-guests",
  searchExperience: "hero-search-experience",
  searchSubmit: "hero-search-submit",
};

export const STAYS = {
  pageGrid: "stays-grid",
  card: (slug) => `stays-card-${slug}`,
  filterPrice: "stays-filter-price",
  filterExperience: "stays-filter-experience",
  filterDestination: "stays-filter-destination",
  filterReset: "stays-filter-reset",
};

export const PROPERTY = {
  bookBtn: "property-book-btn",
  inquireBtn: "property-inquire-btn",
  galleryMain: "property-gallery-main",
};

export const HOME = {
  emergentLink: "home-emergent-link",
  newsletterEmail: "home-newsletter-email",
  newsletterSubmit: "home-newsletter-submit",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  message: "contact-message",
  submit: "contact-submit",
};

export const ADMIN = {
  formName: "admin-form-name",
  formSlug: "admin-form-slug",
  formPrice: "admin-form-price",
  formDest: "admin-form-destination",
  formState: "admin-form-state",
  formExperience: "admin-form-experience",
  formImages: "admin-form-images",
  formTagline: "admin-form-tagline",
  formDescription: "admin-form-description",
  formSubmit: "admin-form-submit",
  deleteBtn: (id) => `admin-delete-${id}`,
};

export default { NAV, HERO, STAYS, PROPERTY, HOME, CONTACT, ADMIN };
